import React from 'react'
import { withTheme } from 'theming'
import { isAndroid, isMobile } from 'react-device-detect'
import ModalBg from '../../assets/download-app-modal-bg.png'
import LumickoLogo from '../../assets/lumicko-logo.png'

const AppRedirectPopup = ({ isOpen, setIsOpen }) => {
  function openAndroidApp() {
    const intentUrl =
      'intent://lumicko.com#Intent;scheme=https;package=com.lumicko.ott;S.browser_fallback_url=https://play.google.com/store/apps/details?id=com.lumicko.ott;end'

    // Try to open the intent
    window.location.href = intentUrl

    // Fallback if the intent doesn't trigger after 2 seconds
    setTimeout(function () {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.lumicko.ott'
    }, 2000)
  }

  function openIosApp() {
    const intentUrl = 'https://apps.apple.com/app/id6753132908'

    // Try to open the intent
    window.location.href = intentUrl

    // Fallback if the intent doesn't trigger after 2 seconds
    setTimeout(function () {
      window.location.href = 'https://apps.apple.com/in/app/lumicko/id6753132908'
    }, 2000)
  }

  return (
    <div
      style={{
        backgroundColor: `#00000090`,
        transition: 'opacity 0.4s ease',
        zIndex: '80',
        display: isMobile && isOpen ? 'flex' : 'none',
      }}
      className="justify-center items-center overflow-x-hidden overflow-y-auto fixed inset-0 outline-none focus:outline-none "
    >
      <div
        style={{ width: '304px', height: '411px' }}
        className={`relative mx-auto flex items-center justify-center text-white`}
      >
        <img src={ModalBg} alt="Modal Background" style={{ width: '100%', height: '100%' }} />
        <div style={{ padding: '28px' }} className="absolute w-full flex flex-col items-center">
          <img
            src={LumickoLogo}
            alt="LumickoLogo"
            style={{ width: '169px', height: '54px', marginTop: '29px' }}
          />
          <div className="mt-5 px-4 text-center w-full">
            <p className=" text-xl font-bold">Lumicko is better with the app</p>
            <p style={{ fontSize: '11px' }} className="mt-5">
              {`For the best way to watch on your mobile device, jump over to the Lumicko app. It's free
            - just tap below!`}
            </p>
          </div>
          <button
            className="text-white w-full text-xs font-bold"
            style={{
              backgroundImage: 'linear-gradient(to left, #fd0003, #c5056d)',
              height: '40px',
              borderRadius: '6px',
              marginTop: '26px',
            }}
            onClick={() => {
              if (isAndroid) {
                openAndroidApp()
              } else {
                openIosApp()
              }
            }}
          >
            Open App
          </button>
          <p
            style={{ color: '#fdfdfd' }}
            className="mt-6 text-center w-full text-xs font-semibold cursor-pointer flex items-center justify-center"
            onClick={() => setIsOpen(false)}
          >
            {`Skip for now`}

            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="10.341"
              height="8.811"
              viewBox="0 0 10.341 8.811"
              className="ml-1"
            >
              <path
                data-name="double-arrow-right-svgrepo-com (1)"
                d="m12.335 15.114 3.557-3.557L12.335 8M7 15.114l3.557-3.557L7 8"
                transform="translate(-6.151 -7.151)"
                style={{
                  fill: 'none',
                  stroke: '#fff',
                  strokeLinecap: 'round',
                  strokeLinejoin: 'round',
                  strokeWidth: '1.2px',
                }}
              />
            </svg>
          </p>
        </div>
      </div>
    </div>
  )
}

export default withTheme(AppRedirectPopup)
